module.exports = __webpack_public_path__ + "img/head-side-cough.70af2c8e.svg";